import { GameLang } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/lang/GameLang";
import { GameFontStyle } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/style/GameFontStyle";
import { GameStyle } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/style/GameStyle";
import { AbstractControlPanelProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/AbstractControlPanelProperties";
import { OptionsProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/OptionsProperties";
import { FontStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/FontStyle";
import { SlingoStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/SlingoStyle";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { ToggleButtonProperties } from "@lib/titan2/dist/game/control/properties/ToggleButtonProperties";
import { Circle, Point } from "pixi.js";
/**
 * ControlPanelLandscapeProperties.ts
 */
export class ControlPanelLandscapeProperties extends AbstractControlPanelProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.logoProperties.position = new Point(183, 83);
        this.logoProperties.scale.set(1);
        const radius = 271 / 2; //from the image size
        const hitArea = new Circle(radius, radius, radius);
        this.spinButtonPosition = new Point(1414, 410);
        this.spinButtonProperties.hitArea = hitArea;
        this.spinButtonProperties.trackingId = GameStyle.SPIN_BUTTON;
        this.freeSpinButtonProperties.textFieldProperties = undefined;
        this.purchaseSpinButtonProperties.textFieldOffset = new Point(0, -40);
        this.purchaseSpinButtonProperties.textFieldProperties.setVerticalAlign(ControlConstants.BOTTOM);
        this.purchaseSpinButtonProperties.textFieldProperties.position = new Point(radius, 125);
        this.purchaseSpinButtonProperties.textFieldProperties.size = new Point(200, 100);
        this.purchaseSpinButtonProperties.textFieldProperties.multiline = true;
        this.purchaseSpinButtonProperties.hitArea = hitArea;
        this.purchaseSpinButtonProperties.disableTextAlpha = 0.6;
        this.startGameButtonProperties.hitArea = hitArea;
        this.payTableButtonProperties.position.set(688, 256);
        this.payTableButtonProperties.textFieldProperties = new TextFieldProperties(FontStyle.PAY_TABLE_BUTTON, undefined, GameLang.OPTIONS_PAYS, ControlConstants.CENTER, ControlConstants.CENTER, new Point(120, 70));
        this.payTableButtonProperties.textFieldProperties.position.y -= this.payTableButtonProperties.textFieldProperties.size.y / 2;
        this.payTableButtonProperties.textFieldOffset.set(0, 0);
        this.freeSpinButtonProperties.hitArea = hitArea;
        this.freeSpinButtonProperties.disableAlign = true;
        this.spinPriceProperties.position = new Point(radius, 120);
        this.spinPriceProperties.size = new Point(200, 100);
        this.collectButtonProperties = new ToggleButtonProperties(SlingoStyle.COLLECT_BUTTON, GameStyle.MODULE, new Point(624, 809));
        this.collectButtonProperties.scale.set(0.735);
        this.collectButtonProperties.textFieldProperties = new TextFieldProperties(FontStyle.COLLECT_BUTTON, new Point(288, 26), GameLang.COLLECT_BUTTON, ControlConstants.CENTER, ControlConstants.CENTER, new Point(340, 160));
        this.collectButtonProperties.disableAlign = true;
        this.collectButtonValueTextFieldProperties = new TextFieldProperties(GameFontStyle.COLLECT_BUTTON_VALUE_TEXT, new Point(670, 24), undefined, ControlConstants.CENTER, ControlConstants.CENTER, new Point(340, 160));
        this.endGameButtonProperties = new ToggleButtonProperties(SlingoStyle.END_GAME_BUTTON, GameStyle.MODULE, new Point(624, 809));
        this.endGameButtonProperties.scale.set(0.735);
        this.endGameButtonProperties.textFieldProperties = new TextFieldProperties(FontStyle.END_GAME_BUTTON, undefined, GameLang.END_GAME_BUTTON, ControlConstants.CENTER, ControlConstants.CENTER, new Point(340, 160));
        this.endGameButtonProperties.textFieldOffset = new Point(0, -12);
    }
}
/**
 * OptionsLandscapeProperties.ts
 */
export class OptionsLandscapeProperties extends OptionsProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.backgroundAlpha = 0.6;
        this.optionsButtonProperties.position = new Point(1546, 115);
        this.panelProperties.position = new Point(699, 190);
        this.panelProperties.scale.set(0.73);
        let size = new Point(500, 100);
        let textFieldOffset = new Point(-235, 0);
        this.backgroundSoundButtonProperties.textFieldProperties.size = size;
        this.backgroundSoundButtonProperties.textFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.backgroundSoundButtonProperties.textFieldOffset = textFieldOffset;
        this.payTableButtonProperties.textFieldProperties.size = size;
        this.payTableButtonProperties.textFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.payTableButtonProperties.textFieldOffset = textFieldOffset;
        this.SFXButtonProperties.textFieldProperties.size = size;
        this.SFXButtonProperties.textFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.SFXButtonProperties.textFieldOffset = textFieldOffset;
        this.backgroundSoundButtonProperties.textFieldProperties.size = size;
        this.backgroundSoundButtonProperties.textFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.backgroundSoundButtonProperties.textFieldOffset = textFieldOffset;
        this.helpButtonProperties.textFieldProperties.size = size;
        this.helpButtonProperties.textFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.helpButtonProperties.textFieldOffset = textFieldOffset;
        this.homeButtonProperties.textFieldProperties.size = size;
        this.homeButtonProperties.textFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.homeButtonProperties.textFieldOffset = textFieldOffset;
        this.depositButtonProperties.textFieldProperties.size = size;
        this.depositButtonProperties.textFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.depositButtonProperties.textFieldOffset = textFieldOffset;
        this.dghButtonProperties.textFieldProperties.size = size;
        this.dghButtonProperties.textFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.dghButtonProperties.textFieldOffset = textFieldOffset;
        this.responsibleGamingButtonProperties.textFieldProperties.size = size;
        this.responsibleGamingButtonProperties.textFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.responsibleGamingButtonProperties.textFieldOffset = textFieldOffset;
        this.hasPayTable = false;
    }
}
//# sourceMappingURL=ControlPanelLandscapeProperties.js.map